import { render, staticRenderFns } from "./update_login_pwd_page.vue?vue&type=template&id=5330205d&scoped=true&"
import script from "./update_login_pwd_page.vue?vue&type=script&lang=js&"
export * from "./update_login_pwd_page.vue?vue&type=script&lang=js&"
import style0 from "./update_login_pwd_page.vue?vue&type=style&index=0&id=5330205d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330205d",
  null
  
)

export default component.exports